import React from "react";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { BackgroundColour } from "../../BuildingBlocks/BackgroundColour";
import { Background } from "../../BuildingBlocks/Background";
import { MinHeight } from "../../BuildingBlocks/MinHeight";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { CRMParagraph } from "../../Simple/CRMParagraph/CRMParagraph";
import CRMInputGeneralComponent from "../../CRMInputs/CRMInputGeneralComponent/CRMInputGeneralComponent";
import CRMInputLabelAndErrorWrapComponent from "../../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import { CRMAutosaveIndicatorWrap } from "../../CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { FormStatus_highestPriority } from "../../../../../shared/src/codecs/codec";
import { TLenderForm } from "../../../../../domain/codecs/form/LenderForm";
import { CasesLenderNameOnPanel1_displayString } from "../../../../../domain/codecs/CasesLenderNameOnPanel";

export const CRMLendersBlock = (props: React.PropsWithChildren<{
    lenderForms: Array<TLenderForm>,
    onChange: (form: TLenderForm) => void,
}>): JSX.Element => {
    const formStatus =
        pipe(
            props.lenderForms,
            array.map(({status}) => status),
            FormStatus_highestPriority,
        );

    return (
        <BackgroundColour colour={CRMColors.NEUTRAL_PAPER}>
            <MinHeight height={"700px"}>
                <Background padding={CRMSpacing.LARGE}>
                    <CRMAutosaveIndicatorWrap
                        width="100%"
                        status={formStatus}
                    >
                        <SpacingColumn spacing={CRMSpacing.LARGE}>
                            <CRMParagraph>
                                The panel number we quote when we write to a lender. It goes on redemption statement requests and gift notices.
                            </CRMParagraph>

                            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                                {props.lenderForms.map((form) =>
                                    <LenderRow
                                        key={form.edited.lender_name}
                                        form={form}
                                        onChange={props.onChange}
                                    />
                                )}
                            </SpacingColumn>
                        </SpacingColumn>
                    </CRMAutosaveIndicatorWrap>
                </Background>
            </MinHeight>
        </BackgroundColour>
    );
};

const LenderRow = (props: {
    form: TLenderForm,
    onChange: (form: TLenderForm) => void,
}): JSX.Element => {
    const onChangePanelNumber = (panel_number: string) =>
        props.onChange({
            ...props.form,
            edited: {
                ...props.form.edited,
                panel_number,
            }
        });

    return (
        <CRMInputLabelAndErrorWrapComponent label={CasesLenderNameOnPanel1_displayString(props.form.edited.lender_name)}>
            <CRMInputGeneralComponent
                value={props.form.edited.panel_number}
                inputType="text"
                placeholder="Panel number"
                onChange={onChangePanelNumber}
                displayError={false}
            />
        </CRMInputLabelAndErrorWrapComponent>
    );
};
